import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import FishermanIcon from '../../../Icon/Icon';
export function getPaginationIndicatorProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onlyPageIndicators = _ref.onlyPageIndicators,
    pageIndicatorIcon = _ref.pageIndicatorIcon,
    activePage = _ref.activePage,
    totalPages = _ref.totalPages,
    disableIndicatorsOnLimit = _ref.disableIndicatorsOnLimit,
    _ref$directionIndicat = _ref.directionIndicatorIcons,
    directionIndicatorIcons = _ref$directionIndicat === void 0 ? {} : _ref$directionIndicat;
  var onFirstPage = _isNumber(activePage) && activePage === 1;
  var onLastPage = _isNumber(activePage) && activePage === totalPages;
  var paginationProps = {};
  if (!_isEmpty(pageIndicatorIcon)) {
    paginationProps = _objectSpread(_objectSpread({}, paginationProps), {}, {
      pageItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: pageIndicatorIcon
        }),
        icon: true
      }
    });
  }
  if (onlyPageIndicators) {
    paginationProps = _objectSpread(_objectSpread({}, paginationProps), {}, {
      boundaryRange: 3,
      ellipsisItem: null,
      firstItem: null,
      lastItem: null,
      nextItem: null,
      prevItem: null,
      siblingRange: 2
    });
  } else {
    paginationProps = _objectSpread(_objectSpread({}, paginationProps), {}, {
      firstItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'firstItem', 'angle double left')
        }),
        icon: true
      },
      lastItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'lastItem', 'angle double right')
        }),
        icon: true
      },
      prevItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'prevItem', 'angle left'),
          disabled: disableIndicatorsOnLimit && onFirstPage
        }),
        icon: true
      },
      nextItem: {
        as: 'div',
        content: /*#__PURE__*/React.createElement(FishermanIcon, {
          iconName: _get(directionIndicatorIcons, 'nextItem', 'angle right'),
          disabled: disableIndicatorsOnLimit && onLastPage
        }),
        icon: true
      }
    });
  }
  return paginationProps;
}